import { handleGetFormDesignWidgetName } from '../render/util';
export const getWidgetSubtableConfig = () => {
    return {
        title: handleGetFormDesignWidgetName,
        group: 'layout',
        icon: 'vxe-icon-subtable',
        options: {
            showCheckbox: false
        }
    };
};
